import { FilterDocuments } from 'shared/constants';
import { useUser } from 'shared/hooks/use-user';

export const useAllTasksFilterDocument = () => {
  const user = useUser();
  return (
    user?.settings?.filters?.allTasks ??
    FilterDocuments.AllTasks.defaultFilterDocument
  );
};
